/**
 * Map tile data structure and utilities
 *
 * A map tile represents the surface view of a chunk column (all Y levels).
 * Each pixel stores the height and material of the highest solid voxel.
 */
import { MAP_TILE_SIZE, MAP_TILE_PIXELS } from './constants.js';
/**
 * Create an empty map tile
 */
export function createMapTile(tx, tz) {
    return {
        tx,
        tz,
        heights: new Int16Array(MAP_TILE_PIXELS),
        materials: new Uint8Array(MAP_TILE_PIXELS),
        _hash: 0,
    };
}
/**
 * Compute a content hash from tile height + material data.
 * Internal — updateTileHash is the public face (was a dead export).
 */
function computeTileHash(tile) {
    let hash = 0;
    for (let i = 0; i < tile.heights.length; i++) {
        hash = ((hash << 5) - hash + tile.heights[i]) | 0;
        hash = ((hash << 5) - hash + tile.materials[i]) | 0;
    }
    return hash;
}
/**
 * Update a tile's cached _hash from its current data.
 */
export function updateTileHash(tile) {
    tile._hash = computeTileHash(tile);
}
/**
 * Get tile key from coordinates
 */
export function mapTileKey(tx, tz) {
    return `${tx},${tz}`;
}
/**
 * Parse tile key to coordinates
 */
export function parseMapTileKey(key) {
    const [tx, tz] = key.split(',').map(Number);
    return { tx, tz };
}
/**
 * Get pixel index from local coordinates
 */
export function tilePixelIndex(lx, lz) {
    return lz * MAP_TILE_SIZE + lx;
}
//# sourceMappingURL=MapTileData.js.map